import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import HomeActive from '../../Assets/Images/home.png';
import Home from '../../Assets/Images/home-img.png';
import Pill from '../../Assets/Images/pill.png';
import Vector1 from '../../Assets/Images/Vector1.png';
import Heart from '../../Assets/Images/heart-attack.png';
import User from '../../Assets/Images/user.png';
import userOrange from "../../Assets/Images/profile-orange.png"
import HeartActive from '../../Assets/Images/heartactive.png'

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleMenuClick = (path) => {
    navigate(path);
  };

  return (
    <div className="icons-menu">
      <div className="menu-item" onClick={() => handleMenuClick('/home')}>
        <img src={location.pathname === '/home' ? HomeActive : Home} alt="home" />
        <span style={{ color: location.pathname === '/home' ? 'orange' : 'black' }}>Home</span>
      </div>
      <div className="menu-item" onClick={() => handleMenuClick('/mymedicine')}>
        <img src={location.pathname === '/mymedicine' ? Vector1 : Pill} alt="medicine" />
        <span style={{ color: location.pathname === '/mymedicine' ? 'orange' : 'black' }}>Medicines</span>
      </div>
      <div className="menu-item" onClick={() => handleMenuClick('/mytest')}>
        <img src={location.pathname === '/mytest' ? HeartActive : Heart} alt="tests" />
        <span style={{ color: location.pathname === '/mytest' ? 'orange' : 'black' }}>My Tests</span>
      </div>
      <div className="menu-item" onClick={() => handleMenuClick('/profile')}>
        <img src={location.pathname === '/profile' ? userOrange : User} alt="profile" />
        <span style={{ color: location.pathname === '/profile' ? 'orange' : 'black' }}>Profile</span>
      </div>
    </div>
  );
};

export default Footer;
